export const blockIconsNavigationChevronLeft = (
	<span className='material-symbols-outlined'>chevron_left</span>
);
